import { authClient, API } from "../../utils/index";

export const searchGoogleFonts = (query = "", limit = 40) => {
	const q = String(query || "").trim();
	return authClient()
		.get(`${API}/google-fonts`, { params: { q, limit } })
		.then((res) => (Array.isArray(res?.data) ? res.data : []));
};
